// 常见问题管理
import http from "@/jslibs/axios/http";

// 列表
export const page = (data) => http.post("/web/contentManager/getCommonProblemList", data);

// 新增
export const add = (data) => http.post("/web/contentManager/addCommonProblem", data);

// 删除
export const del = (data) => http.post("/web/contentManager/deleteCommonProblem", data);

// 详情
export const detail = (data) => http.post("/web/contentManager/getCommonProblemDetail", data);

// 编辑 
export const edit = (data) => http.post("/web/contentManager/updateCommonProblem", data);